import { useCallback, useMemo, useState } from 'react';

import FormikInput from './FormikInput';

type PropsFormikInputPassword = {
  name: string;
  inputProps?: object;
}

enum TypeInput {
  text = 'text',
  password = 'password'
}

export function FormikInputPassword({ name, ...inputProps }: PropsFormikInputPassword) {
  const [isVisible, setIsVisible] = useState(false);
  const iconVisible = useMemo(() => {
    return isVisible ? 'eye' : 'eye-slash';
  }, [isVisible]);

  const inputType = useMemo(() => {
    return isVisible ? TypeInput.text : TypeInput.password;
  }, [isVisible]);

  const toggle = useCallback(() => {
    setIsVisible(!isVisible);
  }, [isVisible]);
  return (
    <FormikInput
      {...inputProps}
      type={inputType}
      icon={iconVisible}
      name={name}
      iconProps={{ onClick: toggle }}
    />
  );
}

export default FormikInputPassword;
